// Used by both the workbench and admin preview: no hidden creative defaults.
export function requiredPrompt(config, key) {
  if (!config) throw new Error('无法读取后台提示词，请稍后重试；本次未提交生成。')
  const text = config[key]
  if (typeof text !== 'string' || !text.trim()) throw new Error(`请先在后台填写并保存提示词：${key}`)
  return text
}

export function renderTemplate(template, values) {
  return (template ?? '').replace(/\$\{([A-Z_]+)\}/g, (token, key) => Object.hasOwn(values, key) ? String(values[key]) : token)
}

export function hasSlot(config, key, slot) {
  // The first promotional image is independent in every mode, including old saved slot selections.
  return slot > 0 && (config[key] ?? '').split(',').map(s => s.trim()).includes(String(slot + 1))
}

export function needsModel(config, women, slot) {
  return women && hasSlot(config, 'promoModelSlots', slot)
}

export function usesBackground(config, women, slot) {
  return hasSlot(config, 'promoBackgroundSlots' + (women ? '' : '_general'), slot)
}

export function composePromo(config, { women = true, slot = 0, mode = 'simple', color = '' } = {}) {
  const suffix = women ? '' : '_general'
  const key = 'promoSlot' + (slot + 1) + (slot === 0 ? '' : suffix)
  const parts = [{ label: '本张图片要求', text: requiredPrompt(config, key) }]
  if (usesBackground(config, women, slot)) {
    const text = config[(mode === 'simple' ? 'simpleModePrompt' : 'lifestyleModePrompt') + suffix] ?? ''
    if (text) parts.push({ label: '所选背景', text })
    if (mode === 'simple' && color && config.simpleColorPromptTemplate) {
      parts.push({ label: '本次颜色', text: renderTemplate(config.simpleColorPromptTemplate, { COLOR: color }) })
    }
  }
  if (hasSlot(config, 'promoConstraintSlots' + suffix, slot) && config['hardConstraints' + suffix]) {
    parts.push({ label: '统一要求', text: config['hardConstraints' + suffix] })
  }
  return { prompt: parts.map(p => p.text).join('\n\n'), parts, modelReference: needsModel(config, women, slot) }
}

export function composeFission(config, hasDetail) {
  return [requiredPrompt(config, 'fissionPrompt'), hasDetail ? config.fissionDetailPrompt : ''].filter(Boolean).join('\n\n')
}

export function composeCopywriting(config, women, input = {}) {
  const suffix = women ? '' : '_general'
  const base = requiredPrompt(config, 'copywritingPrompt' + suffix)
  const context = renderTemplate(config['copywritingContextPrompt' + suffix], {
    FABRIC: input.fabric?.trim() || '未提供',
    SIZE_TYPE: input.sizeType === 'multi' ? '多尺码' : '均码（one size）',
    HAS_SIZE_CHART: input.hasSizeChart === 'yes' ? '有' : '无',
    SELLING_POINTS: input.sellingPoints?.trim() || '未提供'
  })
  return [base, context].filter(Boolean).join('\n\n')
}
